module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0146.jpg?v=20a6204d";